import React from 'react';

import Default from 'components/Responsive/Default';
import Mobile from 'components/Responsive/Mobile';
import HeaderDefault from './HeaderDefault';
import HeaderMobile from './HeaderMobile';


class Header extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function

  render() {
    return (
      <header>
        <Default>
          <HeaderDefault {...this.props} />
        </Default>
        <Mobile>
          <HeaderMobile {...this.props} />
        </Mobile>
      </header>
    );
  }
}

export default Header;
